import * as Sentry from '@sentry/react-router';
import { StrictMode, startTransition } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,

    // クォーター節約のための設定
    sampleRate: import.meta.env.MODE === 'production' ? 0.1 : 1.0, // 本番10%、開発100%
    tracesSampleRate: import.meta.env.MODE === 'production' ? 0.05 : 0.1, // 本番5%、開発10%

    // 不要なデータの送信を制限
    sendDefaultPii: false, // PIIデータの送信を無効化
    // maxBreadcrumbs: 50, // エラー前のアクション履歴の最大数を100から50に削減
    // maxValueLength: 200, // 文字列の最大長を250から200に削減
    // normalizeDepth: 2, // 正規化の深さを3から2に削減
    // normalizeMaxBreadth: 500, // 最大幅を1000から500に削減

    // エラーフィルタリング
    beforeSend(event, hint) {
      const error = hint.originalException;

      // AbortError系のエラーを除外（ページ遷移時の正常な動作）
      if (error instanceof Error) {
        if (error.name === 'AbortError') {
          // 発生タイミング：fetchリクエストが中断された時
          if (error.message.includes('Fetch is aborted')) {
            return null;
          }
          // 発生タイミング：レスポンスボディの読み込み中に中断された時
          if (error.message.includes('BodyStreamBuffer was aborted')) {
            return null;
          }
          // 発生タイミング：ユーザーが明示的にリクエストを中断した時
          if (error.message.includes('The user aborted a request')) {
            return null;
          }
        }

        // IntersectionObserverのエラーを除外（要素が存在しない場合の正常な動作）
        if (error.message.includes('IntersectionObserver') && error.message.includes('parameter 1 is not of type')) {
          return null;
        }

        // Load failed系のエラーを除外（ネットワーク問題）（外部依存するライブラリのエラー）
        if (error.message.includes('Load failed') || error.message.includes('Failed to fetch')) {
          return null;
        }

        // AMP関連のエラーを除外（外部依存するライブラリのエラー）
        if (error.message.includes('__AMP_TOP')) {
          return null;
        }

        // SafeFrame関連のエラーを除外（外部依存するライブラリのエラー）
        if (error.name === 'SecurityError' && error.message.includes('safeframe.googlesyndication.com')) {
          return null;
        }
      }

      return event;
    },

    // 不要なURLからのエラーを除外
    denyUrls: [
      /chrome-extension:\/\//,
      /moz-extension:\/\//,
      /safari-extension:\/\//,
      /edge-extension:\/\//,
      /^chrome:\/\//,
      /^moz-extension:\/\//,
      /^safari-extension:\/\//,
      /^edge-extension:\/\//,
    ],
  });
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>
  );
});
